import { ProjectCategory } from 'src/types/api/Project';

type ProjectCategoryToString = Partial<Record<ProjectCategory, string>>;
export const PROJECT_CATEGORY = Object.freeze<ProjectCategoryToString>({
  WEBTOON: '웹툰',
  WEBNOVEL: '웹소설',
  VIDEO: '영상',
  DOCUMENT: '문서',
});
